module.exports = __webpack_public_path__ + "static/media/image5.55c42e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/image5.jpg
// module id = 650
// module chunks = 0